import React from "react";
import { Code, CreditCard, Megaphone, Users } from "lucide-react";
import { LEAD_INTERCEPTION } from "../shared/leadInterceptionContent.js";

const ICONS = {
  users: Users,
  code: Code,
  megaphone: Megaphone,
  card: CreditCard,
};

const WITHOUT = "Without";

const LeadInterceptionSection = () => (
  <section className="cursor-section roofing-lead-interception" data-testid="roofing-lead-interception">
    <div className="roofing-lead-interception-inner">
      <div className="roofing-lead-interception-grid">
        <div className="roofing-lead-interception-intro">
          <h2 className="roofing-lead-interception-title">{LEAD_INTERCEPTION.title}</h2>
          <p className="roofing-lead-interception-body">{LEAD_INTERCEPTION.body}</p>
        </div>
        <ul className="roofing-lead-interception-list">
          {LEAD_INTERCEPTION.items.map((item) => {
            const Icon = ICONS[item.icon];
            const hasLead = item.text.startsWith(WITHOUT);
            return (
              <li key={item.icon} className="roofing-lead-interception-item">
                <Icon className="roofing-lead-interception-icon" strokeWidth={1.5} aria-hidden="true" />
                <span>
                  {hasLead ? <span className="roofing-lead-interception-accent">{WITHOUT}</span> : null}
                  {hasLead ? item.text.slice(WITHOUT.length) : item.text}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  </section>
);

export default LeadInterceptionSection;
